import { render } from "./home2.vue?vue&type=template&id=5542befd"
import script from "./home2.vue?vue&type=script&lang=js"
export * from "./home2.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hlw/Documents/HBuilderProjects/menhu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__